import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { VeiculosService } from 'app/services/veiculos.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class VeiculosPossesResolver implements Resolve<any> {

    constructor(
        private veiculosService: VeiculosService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.veiculosService.listarPosses();
    }
}
